import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-missions',
  templateUrl: './missions.component.html',
  styleUrls: ['./missions.component.scss']
})
export class MissionsComponent implements OnInit, AfterViewInit {

  constructor(private metaService: MetaService) { }

  ngOnInit(): void {
    // Mettre à jour les meta tags pour cette page
    this.metaService.updateMissionsMeta();
  }

  ngAfterViewInit(): void {
    this.animateCounters();
    this.observeElements();
  }

  /**
   * Anime les compteurs de statistiques
   */
  animateCounters(): void {
    const counters = document.querySelectorAll('.stat-number');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const counter = entry.target as HTMLElement;
          const target = parseInt(counter.getAttribute('data-target') || '0');
          const duration = 2000;
          const startTime = performance.now();
          const startValue = 0;

          const animate = (currentTime: number) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeOutQuart = 1 - Math.pow(1 - progress, 4);
            const currentValue = Math.floor(startValue + (target - startValue) * easeOutQuart);

            counter.textContent = currentValue.toLocaleString();

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              counter.textContent = target.toLocaleString();
            }
          };
          requestAnimationFrame(animate);
          observer.unobserve(counter);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(counter => {
      observer.observe(counter);
    });
  }

  /**
   * Observe les éléments pour les animations AOS
   */
  observeElements(): void {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, { threshold: 0.1 });

    const elements = document.querySelectorAll('[data-aos]');
    elements.forEach(element => {
      observer.observe(element);
    });
  }

  /**
   * Gère le clic sur les cartes de mission
   */
  onMissionCardClick(missionNumber: number): void {
    console.log(`Mission ${missionNumber} clicked`);
    // Ici vous pouvez ajouter la logique pour naviguer vers une page détaillée
    // ou ouvrir une modal avec plus d'informations
  }

  /**
   * Gère le clic sur les cartes de valeur
   */
  onValueCardClick(valueTitle: string): void {
    console.log(`Value ${valueTitle} clicked`);
    // Ici vous pouvez ajouter la logique pour afficher plus d'informations
  }

  /**
   * Gère le clic sur les statistiques
   */
  onStatClick(statLabel: string): void {
    console.log(`Stat ${statLabel} clicked`);
    // Ici vous pouvez ajouter la logique pour afficher un graphique détaillé
  }
}
